import React, { useState } from "react";
import { StudentCarousel } from "@/components/StudentCarousel";
import { useFetchStudents } from "@/hooks/useFetchStudents";
import { StudentOrdering } from "@/types/StudentOrdering";
import { useBuildUrlState } from "@/hooks/useUrlSerializer";
import {
  StudentListLiveEventsSortableFieldEnum,
  SortDirectionEnum,
} from "@/__generated__/graphql";
import { useTranslation } from "react-i18next";
import { useOrg } from "@/hooks/useOrg";
import {
  getPaginationVars,
  newState,
  PaginationState,
} from "@/util/pagination";
import { FilterContext } from "@/types/FilterContext";
import { FilterState } from "@/components/FilterSidebar/FilterState";
import { YesNoEnum } from "@/__generated__/types";

const PAGE_SIZE = 10;

export const GamesAndLiveEventsStudentCarousel = () => {
  const { t } = useTranslation();
  const { org } = useOrg();
  const [paginationState] = useState<PaginationState>(newState(PAGE_SIZE));

  const ordering = new StudentOrdering(
    StudentListLiveEventsSortableFieldEnum.LiveEventsParticipatedAt,
    SortDirectionEnum.Desc,
    "liveEvents",
  );

  const context = new FilterContext("liveEvents");
  const { items: students, loading } = useFetchStudents({
    paginationVariables: getPaginationVars(paginationState),
    context,
    ordering,
    filterState: new FilterState({ hasProfilePhoto: YesNoEnum.Yes }),
  });

  const orderingQuery = useBuildUrlState("STUDENT_ORDERING")(ordering);
  const contextQuery = useBuildUrlState("FILTER_CONTEXT")(context);

  return (
    <StudentCarousel
      students={students}
      title={t("studentCarousel.recentParticipants")}
      isLoading={loading || !org?.id}
      viewAllLink="students"
      viewAllQuery={{ ...contextQuery, ...orderingQuery }}
      viewAllSource="Games and Live Events - Event Participants"
      profileSource="Games & Live Events - Recent Participants"
    />
  );
};
